import { PerspectiveCamera } from '@react-three/drei';
import { ReactNode } from 'react';
import { Vector3 } from 'three';
import { useSnapshot } from 'valtio';

import Backdrop from '@cartwhl/3d/r3f/components/Backdrop';
import ContactShadow from '@cartwhl/3d/r3f/components/ContactShadow';
import Lights from '@cartwhl/3d/r3f/components/Lights';

import { sceneSettingsStore } from 'stores';
import { AnimationPlayerStoreInstance } from 'stores/animationPlayerStoreFactory';

import DefaultCameraControls from './DefaultCameraControls';

export const DEFAULT_LOOK_AT_POSITION = [0, 0.92, 0];
export const DEFAULT_THUMBNAIL_POSITION = [0, 1, 5];
export const DEFAULT_CAMERA_POSITION = [0, 1, 10];
export const DEFAULT_CAMERA_SERIALIZED = JSON.stringify({
  positionX: DEFAULT_CAMERA_POSITION[0],
  positionY: DEFAULT_CAMERA_POSITION[1],
  positionZ: DEFAULT_CAMERA_POSITION[2],
  targetX: 0,
  targetY: 0,
  targetZ: 0,
});

export default function SceneSetup({
  animationPlayerStore,
  cameraPosition = new Vector3(...DEFAULT_CAMERA_POSITION),
  cameraControls,
}: {
  animationPlayerStore: AnimationPlayerStoreInstance;
  cameraPosition?: Vector3;
  cameraControls?: ReactNode;
}) {
  const {
    backgroundSettings: { useBackgroundGradient, enableShadows, hexColor },
  } = useSnapshot(sceneSettingsStore.state);

  return (
    <>
      <Lights />

      <Backdrop
        useBackgroundGradient={useBackgroundGradient}
        hexColor={hexColor}
      />

      {enableShadows && <ContactShadow />}

      <PerspectiveCamera makeDefault position={cameraPosition} zoom={2} />

      {cameraControls !== undefined ? (
        cameraControls
      ) : (
        <DefaultCameraControls animationPlayerStore={animationPlayerStore} />
      )}
    </>
  );
}
